import { render, staticRenderFns } from "./CreateProjectDialog.vue?vue&type=template&id=42b22862&scoped=true&"
import script from "./CreateProjectDialog.vue?vue&type=script&lang=js&"
export * from "./CreateProjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b22862",
  null
  
)

export default component.exports